import axios from 'axios';

export const apiService = {
  getGeolocation: async () => {
    try {
      const response = await axios.get('https://validationapi.thetechmenders.com/api/GeoLocation/GetGeoLocation');
      return response.data;
    } catch (error) {
      console.error('Geolocation error:', error);
      return null;
    }
  },

  submitLead: async (leadData) => {
    try {
      const response = await axios.post('https://leadapi.crmbytes.com/api/Lead/AddLead', leadData);
      return { status: response.status, data: response.data };
    } catch (error) {
      if (error.response) {
        return { status: error.response.status, data: error.response.data };
      }
      return { status: 500, data: { errorMessage: 'Network error. Please try again.' } };
    }
  }
};
